import React, { Component } from 'react'
import { Element } from 'react-scroll'
import { Navbar, Nav, NavItem } from 'react-bootstrap'
import _ from 'lodash'
import S from 'shorti'
import cn from 'classnames'
import config from '../../../../config/public'
import getVideoId from 'get-video-id'
import Brand from '../../../models/Brand'
const { NODE_ENV, BUILDING } = process.env
if (NODE_ENV === 'development' || BUILDING === 'true')
  require('./assets/styles/main.scss')

class IFrame extends React.Component {
  constructor() {
    super();
    this.state = {
      iFrameHeight: 500
    }
  }

  componentDidMount() {
    window && window.addEventListener("message", this.handleFrameTasks);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleFrameTasks);
  }

  handleFrameTasks = (e) => {
    if (
      e.data
      && e.data.height
      && e.data.height !== this.state.iFrameHeight
    )
      this.setState({
        "iFrameHeight": e.data.height
      });
  }

  render() {
    return (
      <iframe
        src={this.props.src}
        ref={(f) => {
          this.ifr = f;
        }}
        height={this.state.iFrameHeight + 'px'}
        scrolling="no"
        frameBorder="0"
      />
    );
  }
}

class Template extends Component {
  getAsset = (asset) => {
    const base = (NODE_ENV === 'development' || BUILDING === 'true') ?
      '/assets/images/' :
      '/images/'
    return base + asset
  }
  getHighlightArea() {
    const data = this.props.data
    const website = data.website || this.props.website
    const { attributes } = website
    let first_width = '50p'
    let second_width = '50p'
    let second_left = '50p'
    let has_second_area = true
    if (!attributes.highlight_image_2 && !attributes.highlight_video_2) {
      first_width = '100p'
      has_second_area = false
    }
    if (typeof window !== 'undefined' && window.innerWidth < 768) {
      first_width = '100p'
      second_width = '100p'
      second_left = 0
    }
    let first_area = <div className="highlight-media" style={ { ...S(`w-${first_width} h-100p minh-400 l-0 bg-cover border-right-1-solid-fff bg-center bg-url(${attributes.highlight_image_1 || (data.steps ? this.getAsset('pool.jpg') : '')})`) } }/>
    if (attributes.highlight_video_1) {
      const video = getVideoId(attributes.highlight_video_1)
      if (video) {
	      let url
	      if (video.service === 'youtube')
		      url = `https://www.youtube.com/embed/${video.id}`
	      else
		      url = `https://player.vimeo.com/video/${video.id}`
	      first_area = (
		      <div className="highlight-media"
		           style={{ ...S(`w-${first_width} h-100p minh-400 l-0 border-right-5-solid-fff`) }}>
			      <iframe width="100%" height="100%" src={url} frameBorder="0" />
		      </div>
	      )
      }
    }
    let second_area = <div className="highlight-media" style={ { ...S(`w-${second_width} h-100p minh-400 l-${second_left} bg-cover bg-center bg-url(${attributes.highlight_image_2 || (data.steps ? this.getAsset('nora.png') : '')})`) } }/>
    if (attributes.highlight_video_2) {
      const video = getVideoId(attributes.highlight_video_2)
	    if (video) {
		    let url
		    if (video.service === 'youtube')
			    url = `https://www.youtube.com/embed/${video.id}`
		    else
			    url = `https://player.vimeo.com/video/${video.id}`
		    second_area = (
			    <div className="highlight-media" style={{ ...S(`w-${second_width} h-100p minh-400 l-${second_left}`) }}>
				    <iframe width="100%" height="100%" src={url} frameBorder="0" />
			    </div>
		    )
	    }
    }
    return (
      <div>
        { first_area }
        { has_second_area ? second_area : '' }
      </div>
    )
  }
  showListingMap() {
    this.props.showListingMap()
  }
  hideListingMap() {
    this.props.hideListingMap()
  }
  render() {
    const data = this.props.data
    if (!data)
      return <div></div>
    const website = data.website || this.props.website
    let brand = data.brand
    if (website && website.brand && website.brand.id)
      brand = website.brand
    if (!website)
      return <div className="loading"></div>
    const { attributes, user } = website
    const getSocialIcons = (noScroll = false) => {
      const list = [
        { site: 'facebook', url: attributes.facebook_url},
        { site: 'twitter', url: attributes.twitter_url },
        { site: 'instagram', url: attributes.instagram_url }
      ].filter(social => social.url !== null && social.url !== '')
      if (list.length === 0)
        return false
      return (
        <div>
          <ul>
            {
              list.filter(s => s.url && s.url.trim()).map(s => {
                  return (
                    <li key={`social_${s.site}`}>
                      <a href={s.url}>
                        <i className={`fa fa-${s.site}`} />
                      </a>
                    </li>
                  )
              })
            }
          </ul>
        </div>
      )
    }
    const highlights = [
      attributes.highlight_1,
      attributes.highlight_2,
      attributes.highlight_3,
      attributes.highlight_4,
      attributes.highlight_5
    ]
      .filter(hg => hg ).map((hg, key) => {
        return <li key={`hg_${hg + key}`}><i className="fa fa-check icon"></i>{hg}</li>
    })
    // Listings area
    let listings_area


    let agent_id
    if (website.user && website.user.agent)
      agent_id = website.user.agent.id

    let url = brand ? brand.base_url : config.rechat_url

    url += `/widgets/listings?`

    if (brand)
      url += `brand=${brand.id}`
    else
      url += `agent=${agent_id}`

    const brandPrimaryColor = Brand.color('primary', '#00B286', brand)

    listings_area = <IFrame
      src={url}
      height="500"
    />

    let chat_area
    if (website.user && website.user.agent) {
      chat_area = (
        <div className="help futura" style={ S('mb-50') }>
          <p style={ S('fw-300 font-32') }>Need help looking for the perfect home? I can help you.</p>
          <a style={ {...S('pl-50 pr-50 h-50 pt-15 border-none color-fff'), backgroundColor: brandPrimaryColor} } target="_parent" href={`${brand ? brand.base_url : config.rechat_url}/signup?inviting_user=${user.id}`} className="btn btn-primary">
            <i className="fa fa-comments-o" style={ S('mr-5') }/>
            ASK ME A QUESTION
          </a>
        </div>
      )
    }
    let find_home_area
    if (website.user && website.user.agent) {
      find_home_area = (
        <div className="btn-find futura">
          <a className="btn btn-primary uppercase" href={`${brand ? brand.base_url : config.rechat_url}/signup?inviting_user=${user.id}`} style={{...S('pl-50 pr-50 h-50 pt-15 border-none'), backgroundColor: brandPrimaryColor}}>
            <i className="fa fa-search" style={ S('mr-5') }/>
            find your dream home
          </a>
        </div>
      )
    }
    let quote_content = (
      <table style={ S('w-100p') }>
        <tbody>
          <tr>
            <td style={ S('w-50p p-50') }>
              <Element
                name="step-8"
                className={ cn('element', { 'dashed-border': data.step === 8 }) }
              >
                <p
                  className="quote"
                  onClick={ this.props.goToStep.bind(this, 8) }
                  style={ { lineHeight: '32px' } }
                >
                  “{ attributes.quote }”
                </p>
              </Element>
            </td>
            <td style={ S('w-50p') }>
              <div>
                <div>
                  <h2 className="futura" style={ { ...S('font-14 color-b2b7bd'), textTransform: 'uppercase' } }>ABOUT {user.display_name}</h2>
                </div>
                <Element
                  name="step-9"
                >
                  <div className={ cn({ 'dashed-border': data.step === 9 }) }>
                    <p
                      onClick={ this.props.goToStep.bind(this, 9) }
                      dangerouslySetInnerHTML={ { __html: attributes.bio.replace(/(?:\r\n|\r|\n)/g, '<br />') } }
                    />
                  </div>
                </Element>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    )
    if (typeof window !== 'undefined' && window.innerWidth < 500) {
      quote_content = (
        <div>
          <div>
            <p className="quote" style={ { lineHeight: '32px' } }>
              “{ attributes.quote }”
            </p>
          </div>
          <div>
            <h2 className="futura" style={ { ...S('font-14 color-b2b7bd'), textTransform: 'uppercase' } }>ABOUT {user.display_name}</h2>
            <p>
              { attributes.bio }
            </p>
          </div>
        </div>
      )
    }
    let main_area = (
      <div>
        <main>
          <Element
            name="step-2"
            className={ cn('cover', 'element', { 'sonar-wrapper': data.step === 2 }, { 'dashed-border': data.step === 2 }) }
            onClick={ this.props.goToStep.bind(this, 2) }
            style={ { ...S(`bg-url(${attributes.cover_image || (data.steps ? this.getAsset(`hero-1.jpg`) : '') }) mb-40`), backgroundPosition: 'top' } }
          >
          </Element>
          <div className='container'>
            <div className="information">
              <h1 className="name" style={ { ...S('fw-600 mb-20 font-40 mb-20 fw-300'), textTransform: 'uppercase' } }>{user.display_name}</h1>
              <Element name="step-3" className={cn('element', {'sonar-wrapper': data.step === 3 }, { 'dashed-border': data.step === 3 })}>
                <p
                  className="description"
                  onClick={ this.props.goToStep.bind(this, 3) }
                  style={ S('font-24 mb-20') }
                >
                  { attributes.tagline }
                </p>
              </Element>
            </div>
            <div className="properties" style={ S('mb-40') }>
              { !attributes.team_info_name_1 &&
                <div>
                  <span><a href={`mailto:${user.email}`}>{user.email}</a></span>
                  { user.phone_number &&
                    <span>&nbsp;&nbsp;|&nbsp;&nbsp;<a href={`tel:${user.phone_number}`}>{user.phone_number.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '($2) $3-$4').replace('+', '') }</a></span>
                  }
                </div>
              }
              <Element
                name="step-4"
                onClick={ this.props.goToStep.bind(this, 4) }
              >
                { attributes.team_info_name_1 &&
                  <div>
                    <span>{ attributes.team_info_name_1 }</span>
                    <span>{ attributes.team_info_phone_1 ? <span>&nbsp;&nbsp;|&nbsp;&nbsp;<a href={`tel:${attributes.team_info_phone_1}`}>{ attributes.team_info_phone_1 }</a></span> : '' }</span>
                  </div>
                }
                { attributes.team_info_name_2 &&
                  <div>
                    <span>{ attributes.team_info_name_2 }</span>
                    <span>{ attributes.team_info_phone_2 ? <span>&nbsp;&nbsp;|&nbsp;&nbsp;<a href={`tel:${attributes.team_info_phone_2}`}>{ attributes.team_info_phone_2 }</a></span> : '' }</span>
                  </div>
                }
                { attributes.team_info_name_3 &&
                  <div>
                    <span>{ attributes.team_info_name_3 }</span>
                    <span>{ attributes.team_info_phone_3 ? <span>&nbsp;&nbsp;|&nbsp;&nbsp;<a href={`tel:${attributes.team_info_phone_3}`}>{ attributes.team_info_phone_3 }</a></span> : '' }</span>
                  </div>
                }
              </Element>
            </div>
            <div style={ S('mb-40') }>{ find_home_area }</div>
            <hr style={ S('mb-40') } />
            <Element
              name="step-5"
              className={ cn('social element', {'dashed-border': data.step === 5 }) }
              style={ S('h-50') }
              onClick={ this.props.goToStep.bind(this, 5) }
            >
              { getSocialIcons() }
            </Element>
          </div>
          <section
            id="highlights"
            className='row highlights'
            ref={div => this.highlights = div }
          >
            <a name="highlights"></a>
            <div className="highlights-flex">
              <div className="col-lg-5 col-md-5 col-sm-6 col-xs-12 content" style={ S(`${typeof window !== 'undefined' && window.innerWidth > 500 ? 'p-100' : 'p-40'}`) }>
                <div>
                  <h2 className="futura" style={ S('font-14') }>QUICK HIGHLIGHTS</h2>
                </div>
                <Element
                  name="step-6"
                  className={ cn('element', { 'dashed-border': data.step === 6 }) }
                  onClick={ this.props.goToStep.bind(this, 6) }
                >
                  <ul>
                    { highlights }
                  </ul>
                </Element>
              </div>
              <Element
                name="step-7"
                className={ cn('col-lg-7 col-md-7 col-sm-6 col-xs-12 element', { 'dashed-border': data.step === 7 }) }
                onClick={ this.props.goToStep.bind(this, 7) }
              >
                { this.getHighlightArea() }
              </Element>
              <div className="clearfix"></div>
            </div>
          </section>
          <section
            className={ cn('row about', { 'sonar-wrapper': data.step === 8 }) }
            ref={div => this.about = div }
            style={ S(`${typeof window !== 'undefined' && window.innerWidth > 500 ? 'p-100' : 'p-40'}`) }
          >
            <a name="about"></a>
            { quote_content }
          </section>

          <section
            className="listings"
            ref={div => this.my_listings = div }
          >
            <a name="listings"></a>

            <div className="listings-widget-container">
              { listings_area }
            </div>
          </section>
        </main>
        <footer>
          {
            user &&
            <div>
              <div className="info">
                { user.profile_image_url &&
                  <div style={ S(`mb-15 bg-url(${user.profile_image_url}) w-150 h-150 bg-center bg-cover center-block br-150`) } alt={user.display_name} />
                }
                <p className="name">{user.display_name ? user.display_name.toUpperCase() : '' }</p>
                { !attributes.team_info_name_1 &&
                  <p className="properties">{user.phone_number ? 'M: ' + user.phone_number.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '($2) $3-$4').replace('+', '') + ', ' : ''}E: {user.email}</p>
                }
                { attributes.team_info_name_1 &&
                  <div style={ S('color-fff') }>
                    <span>{ attributes.team_info_name_1 }&nbsp;&nbsp;<a href={`tel:${attributes.team_info_phone_1}`}>{ attributes.team_info_phone_1 }</a></span>
                  </div>
                }
                { attributes.team_info_name_2 &&
                  <div style={ S('color-fff') }>
                    <span>{ attributes.team_info_name_2 }&nbsp;&nbsp;<a href={`tel:${attributes.team_info_phone_2}`}>{ attributes.team_info_phone_2 }</a></span>
                  </div>
                }
                { attributes.team_info_name_3 &&
                  <div style={ S('color-fff') }>
                    <span>{ attributes.team_info_name_3 }&nbsp;&nbsp;<a href={`tel:${attributes.team_info_phone_3}`}>{ attributes.team_info_phone_3 }</a></span>
                  </div>
                }
                { chat_area }
              </div>
              <div style={ S('pb-50') } className="card">
                <div className="inner row">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <a href={ attributes.general_info_link || 'https://lo.primelending.com/rwatterson' } target="_blank">
                      <img role="presentation" style={ S('w-100p') } src={ attributes.general_info_image || this.getAsset('prime.png') } alt="" />
                    </a>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 futura">
                    <ul style={ S('font-16') }>
                      <li>
                        <Element
                          name="step-10"
                          className={ cn({'dashed-border': data.step === 10 }) }
                          onClick={ this.props.goToStep.bind(this, 10) }
                        >
                        { attributes.general_info_1 }<br/>
                        { attributes.general_info_2 }<br/>
                        { attributes.general_info_3 }<br/>
                        { attributes.general_info_4 }<br/>
                      </Element>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          }
          <div className="links" style={ S('pt-70') }>
            <ul className="nv-links futura" style={ S('mb-50') }>
              <li><a style={ S('color-fff op-.7') } onClick={e => this.selectMenu(e, 'highlights')} href="#highlights">HIGHLIGHTS</a></li>
              <li><a style={ S('color-fff op-.7') } onClick={e => this.selectMenu(e, 'about')} href='#about'>ABOUT</a></li>
              <li><a style={ S('color-fff op-.7') } onClick={e => this.selectMenu(e, 'my_listings')} href="#listings">LISTINGS</a></li>
            </ul>
            <div style={ S('mb-40') }>
              <Element
                className={ cn('social element', {'dashed-border': data.step === 5 }) }
                style={ S('h-50') }
                onClick={ this.props.goToStep.bind(this, 5) }
              >
                { getSocialIcons(true) }
              </Element>
            </div>
            <div className="copyright futura" style={ S('w-200 center-block mb-40') }>
              Powered by <a href={`${brand ? brand.base_url : config.rechat_url}`} target="_blank" style={ S('fw-600') }>Rechat™</a>
            </div>
          </div>
        </footer>
      </div>
    )
    if (data.show_listing_map) {
      main_area = (
        <div>
          <iframe frameBorder="0" src={`${brand ? brand.base_url : config.rechat_url}/widgets/map?agent=${agent_id}`} style={ S(`h-${window.innerHeight - 115} w-100p`) }></iframe>
        </div>
      )
    }
    return (
      <div className="futura template__light" style={ { ...S('bg-fff'), overflow: 'hidden' } }>
        <header>
          <Navbar style={ S('border-none bg-fff pt-20') }>
            {
              attributes.logo_url &&
              <Navbar.Header>
                <Navbar.Brand>
                  <Element
                    className={ cn('social element', {'dashed-border': data.step === 1 }) }
                    onClick={ this.props.goToStep.bind(this, 1) }
                    name="step-1"
                  >
                    <a href="">
                      <img role="presentation" style={ S('h-60 mt-20n') } src={attributes.logo_url} alt="" />
                    </a>
                  </Element>
                </Navbar.Brand>
                <Navbar.Toggle />
              </Navbar.Header>
            }
            {
              !attributes.logo_url && brand &&
              <Navbar.Header>
                <Navbar.Brand>
                  <Element
                    className={ cn('social element', {'dashed-border': data.step === 1 }) }
                    onClick={ this.props.goToStep.bind(this, 1) }
                    name="step-1"
                  >
                    <a href="">
                      <img role="presentation" style={ S('h-60 mt-20n') } src={brand.assets ? brand.assets.office_logo : ''} alt="" />
                    </a>
                  </Element>
                </Navbar.Brand>
                <Navbar.Toggle />
              </Navbar.Header>
            }
            <Navbar.Collapse style={ S('border-none') }>
              <Nav pullRight>
                <NavItem eventKey={1} onClick={ this.hideListingMap.bind(this, 'highlights') } href="#highlights" style={ S('color-263445') }>HIGHLIGHTS</NavItem>
                <NavItem eventKey={2} onClick={ this.hideListingMap.bind(this, 'about') } href='#about' style={ S('color-263445') }>ABOUT</NavItem>
                <NavItem eventKey={2} onClick={ this.hideListingMap.bind(this, 'listings') } href="#listings" style={ S('color-263445') }>LISTINGS</NavItem>
                <NavItem eventKey={2} href="#"><a onClick={ this.showListingMap.bind(this) } href="#map" style={{...S(`p-10 br-3 color-fff`), backgroundColor: brandPrimaryColor}}><i className="fa fa-search"></i>&nbsp;&nbsp;Search Listings</a></NavItem>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </header>
        { main_area }
      </div>
    )
  }
}
module.exports = Template


// WEBPACK FOOTER //
// ./src/components/Templates/light/index.js